import { render, staticRenderFns } from "./PendingAndUserModifiedGroup.vue?vue&type=template&id=44af3910"
import script from "./pendingAndUserModifiedGroup.ts?vue&type=script&lang=ts&external"
export * from "./pendingAndUserModifiedGroup.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44af3910')) {
      api.createRecord('44af3910', component.options)
    } else {
      api.reload('44af3910', component.options)
    }
    module.hot.accept("./PendingAndUserModifiedGroup.vue?vue&type=template&id=44af3910", function () {
      api.rerender('44af3910', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/shared/team-request-detail/buttons-group/groups/manager/pending-and-user-modified-group/PendingAndUserModifiedGroup.vue"
export default component.exports